import apiClient from './apiClient';
import type { SieveNest, SieveNestSize } from '../types/sieveNest';

export const listSieveNests = async (): Promise<SieveNest[]> => {
  const r = await apiClient.get<SieveNest[]>('/sieve-nests');
  return r.data;
};

export const createSieveNest = async (
  nestName: string,
  description?: string | null,
): Promise<SieveNest> => {
  const r = await apiClient.post<SieveNest>('/sieve-nests', { nestName, description });
  return r.data;
};

export const updateSieveNest = async (
  key: string,
  nestName: string,
  description?: string | null,
): Promise<SieveNest> => {
  const r = await apiClient.put<SieveNest>(`/sieve-nests/${key}`, { nestName, description });
  return r.data;
};

export const deleteSieveNest = async (key: string): Promise<void> => {
  await apiClient.delete(`/sieve-nests/${key}`);
};

export const addSieveNestSize = async (
  nestKey: string,
  size: { sieveSizeMm: number; sieveDesignation?: string; sieveDisplayName?: string; sortOrder?: number },
): Promise<SieveNestSize> => {
  const r = await apiClient.post<SieveNestSize>(`/sieve-nests/${nestKey}/sizes`, size);
  return r.data;
};

export const updateSieveNestSize = async (
  nestKey: string,
  sizeKey: string,
  size: { sieveSizeMm: number; sieveDesignation?: string; sieveDisplayName?: string; sortOrder?: number },
): Promise<SieveNestSize> => {
  const r = await apiClient.put<SieveNestSize>(`/sieve-nests/${nestKey}/sizes/${sizeKey}`, size);
  return r.data;
};

export const deleteSieveNestSize = async (
  nestKey: string,
  sizeKey: string,
): Promise<void> => {
  await apiClient.delete(`/sieve-nests/${nestKey}/sizes/${sizeKey}`);
};
